'use strict';

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _fromPairs = require('lodash/fp/fromPairs');
var _map = require('lodash/fp/map');
var _toPairs = require('lodash/fp/toPairs');
var _flow = require('lodash/fp/flow');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _fromPairs__default = /*#__PURE__*/_interopDefaultLegacy(_fromPairs);
var _map__default = /*#__PURE__*/_interopDefaultLegacy(_map);
var _toPairs__default = /*#__PURE__*/_interopDefaultLegacy(_toPairs);
var _flow__default = /*#__PURE__*/_interopDefaultLegacy(_flow);

var parseDataAttributes = function parseDataAttributes() {
  var dataAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _flow__default["default"](_toPairs__default["default"], _map__default["default"](function (_ref) {
    var _ref2 = _slicedToArray__default["default"](_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    return ["data-".concat(name), value];
  }), _fromPairs__default["default"])(dataAttributes);
};

exports.parseDataAttributes = parseDataAttributes;
//# sourceMappingURL=parseDataAttributes-81c8dbee.js.map
